const recommendation = [
  {
    name: "Marcello Menezes - Desenvolvedor BackEnd na Stefanini",
    message:
      '"Carlos é uma pessoa muito dedicada, sempre buscando ajudar os companheiros e demais colegas de equipe."',
    social: "https://www.linkedin.com/in/marcelloaugustom/",
  },
];

export default recommendation;
